import { BaseModel } from '../../_base/crud';

export class Category extends BaseModel {
  id: number;
  company_id: number;
  name: string;
  roles: any;
  email: string;
  fax_number: any;
  inbox_activated: boolean;
  fax_activated: boolean;
  inbox_id: any;
  inbox: any;
  has_intervention_permission: boolean;
  is_default_intervention_team: boolean;
  managers: any;
  is_active: boolean;
}
